import CategoryGroup from "./CategoryGroup/CategoryGroup";
import "./CategoryList.css";

const CategoryList = ({groupedCategories, selected, setSelected}) => {
    return (
        <div className="categoriesContainer">
            { groupedCategories.map(categoryGroup => 
                <CategoryGroup categoryGroup={categoryGroup} selected={selected} setSelected={setSelected}/>
            )}
        </div>
    )
}

export default CategoryList;